import { AUTOCOMPLETE_ENDPOINT, HERE_MAPS_API_KEY, USER_LANGUAGE } from '@/app/config';

const getAutocompleteUrl = ({ searchTerm }: { readonly searchTerm: string }): string => {
  const searchParameters = new URLSearchParams();
  searchParameters.set('lang', USER_LANGUAGE);
  searchParameters.set('q', searchTerm);
  searchParameters.set('limit', '4');
  searchParameters.set('apiKey', HERE_MAPS_API_KEY);

  return `${AUTOCOMPLETE_ENDPOINT}/v1/autocomplete?${searchParameters.toString()}`;
};

export default getAutocompleteUrl;
